import { BlocklistRulesModule } from '@nirvana/shared/dtos/types/policies/common';

// UI form value format
export interface BlocklistRulesFormValue {
  uiSettings: { blocklistRules: BlocklistRulesModule };
}

// searchable keywords
export enum BlocklistRulesSearchableKeywords {
  BlocklistRules = 'BlocklistRules',
  ApplicationHash = 'ApplicationHash',
  DllFiles = 'DllFiles',
  ScriptFiles = 'ScriptFiles',
  ApplicationPath = 'ApplicationPath',
  NetworkConnection = 'NetworkConnection',
}
